import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-draft',
  imports: [],
  templateUrl: './icon-draft.component.html',
})
export class IconDraftComponent {
  color = input('#4f4f4f');
}
